import pages from '../namespaces/pages/ja';
import components from '../namespaces/components/ja';
import common from '../namespaces/common/ja';
import errors from '../namespaces/errors/ja';
import validation from '../namespaces/validation/ja';
import gameDetail from '../namespaces/gameDetail/ja';

export default {
  common,
  pages,
  components,
  errors,
  validation,
  gameDetail
}; 